// extracted by mini-css-extract-plugin
module.exports = {"modal_border_radius":"Modal_modal_border_radius__f9G1N"};